import { Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import AppTopBar from './AppTopBar';

const AppShell = () => (
  <div className="app-shell">
    <AppSidebar />
    <div className="app-shell__main">
      <AppTopBar />
      <main className="app-shell__content">
        <Outlet />
      </main>
    </div>
  </div>
);

export default AppShell;